export enum FormSelectionType {
  Single,
  Multiple,
}